import { Outlet } from 'react-router-dom'
import { LiveWorkChip } from './Topbar.jsx'

// Inner layout for full-screen wizard flows (new lead, invite team). The
// persistent sidebar is provided by the parent <Shell>; the wizard fills the
// remaining space edge-to-edge (no Topbar / page padding — the wizard supplies
// its own chrome, including a Back button).
export default function WizardLayout() {
  return (
    <div className="flex h-full flex-1 flex-col overflow-y-auto bg-panel p-0">
      {/* Background work must have UI on these routes too. There is no Topbar
          here, and a run or stream live while someone is mid-wizard (staging a
          campaign draft, say) would otherwise be running with no UI anywhere —
          the exact half of the historical bug the host's construction promises
          cannot recur. The chip floats top-right: sticky with zero height, so
          it takes no layout space from the wizard and stays put while the
          wizard scrolls; it renders nothing at all when the host is idle. */}
      <div className="pointer-events-none sticky top-3 z-40 flex h-0 justify-end pr-4">
        <span className="pointer-events-auto">
          <LiveWorkChip />
        </span>
      </div>
      <Outlet />
    </div>
  )
}
